<template>
  <div class="comp-container">
    <div class="title">
      <img src="@saas/pages/assets/images/live-data/ranking.png" alt="" />
      <p>学员排名</p>
      <div class="more-btn" @click="handleClickMore">
        <span>查看全部</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="comp-content">
      <!-- 表格头部 -->
      <div class="table-header">
        <div class="header-cell student-name-header">学生昵称</div>
        <div class="header-cell time-header">奖杯数量</div>
        <div class="header-cell course-header">上台次数</div>
        <div class="header-cell progress-header">上台时间</div>
        <div class="header-cell progress-header">正确率</div>
        <div class="header-cell progress-header">在线</div>
      </div>

      <!-- 表格内容 -->
      <div class="student-table-body">
        <div
          v-for="(item, index) in preThreeData"
          :key="index"
          class="student-table-row"
        >
          <div class="row-content">
            <div class="student-info">
              <div
                class="avatar"
                :style="{ backgroundColor: item.avatarColor }"
              >
                <img
                  v-if="index === 0"
                  src="@saas/pages/assets/images/live-data/first.png"
                  alt=""
                />
                <img
                  v-else-if="index === 1"
                  src="@saas/pages/assets/images/live-data/second.png"
                  alt=""
                />
                <img
                  v-else-if="index === 2"
                  src="@saas/pages/assets/images/live-data/third.png"
                  alt=""
                />
              </div>
              <div
                class="avatar"
                :style="{ backgroundColor: item.avatarColor }"
              >
                <img v-if="item.avatar" :src="item.avatar" alt="" />
              </div>
              <span class="student-name ellipsis">{{ item.nickname }}</span>
            </div>
            <div class="data-cell time-cell">
              {{ item.trophy_count || 0 }}
            </div>
            <div class="data-cell time-cell">
              {{ item.up_stage_count || 0 }}
            </div>
            <div class="data-cell time-cell">
              {{ formatTimeBySecond(item.up_stage_duration) }}
            </div>
            <div class="data-cell course-cell">
              {{
                item.total_num === 0
                  ? 0
                  : ((item.right_num / item.total_num) * 100).toFixed(2)
              }}%
            </div>
            <div class="data-cell progress-cell">
              {{ formatTimeBySecond(item.stay_duration) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="590px"
      :close-on-click-modal="false"
      custom-class="student-dialog"
      @close="handleDialogClose"
    >
      <div class="dialog-content">
        <!-- 表格头部 -->
        <div class="table-header">
          <div class="header-cell student-name-header">学生昵称</div>
          <div class="header-cell time-header">奖杯数量</div>
          <div class="header-cell course-header">上台次数</div>
          <div class="header-cell progress-header">上台时间</div>
          <div class="header-cell progress-header">正确率</div>
          <div class="header-cell progress-header">在线</div>
        </div>

        <!-- 表格内容 -->
        <div class="student-table-body">
          <template v-if="tableData.length">
            <div
              v-for="(item, index) in tableData"
              :key="index"
              class="student-table-row"
            >
              <div class="row-content">
                <div class="student-info">
                  <div
                    class="avatar"
                    :style="{ backgroundColor: item.avatarColor }"
                  >
                    <img
                      v-if="index === 0 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/first.png"
                      alt=""
                    />
                    <img
                      v-else-if="index === 1 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/second.png"
                      alt=""
                    />
                    <img
                      v-else-if="index === 2 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/third.png"
                      alt=""
                    />
                    <div v-else>
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </div>
                  </div>
                  <div
                    class="avatar"
                    :style="{ backgroundColor: item.avatarColor }"
                  >
                    <img v-if="item.avatar" :src="item.avatar" alt="" />
                  </div>
                  <span class="student-name ellipsis">{{ item.nickname }}</span>
                </div>
                <div class="data-cell time-cell">
                  {{ item.trophy_count || 0 }}
                </div>
                <div class="data-cell time-cell">
                  {{ item.up_stage_count || 0 }}
                </div>
                <div class="data-cell time-cell">
                  {{ formatTimeBySecond(item.up_stage_duration) }}
                </div>
                <div class="data-cell course-cell">
                  {{
                    item.total_num === 0
                      ? 0
                      : ((item.right_num / item.total_num) * 100).toFixed(2)
                  }}%
                </div>
                <div class="data-cell progress-cell">
                  {{ formatTimeBySecond(item.stay_duration) }}
                </div>
              </div>
            </div>
          </template>
          <el-empty
            v-else
            description="暂无内容"
            :image="require('@/assets/img/live-list/empty.png')"
          ></el-empty>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
          <div class="pagination">
            <button
              class="pagination-btn prev"
              :disabled="currentPage === 1"
              @click="handlePrevPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="上一页"
              />
            </button>
            <div class="pagination-info">
              <span class="current-page">{{ currentPage }}</span>
              <span class="separator">/</span>
              <span class="total-pages">{{ totalPages }}</span>
            </div>
            <button
              class="pagination-btn next"
              :disabled="currentPage === totalPages"
              @click="handleNextPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="下一页"
              />
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStudentRankList } from "@saas/service-api/src/live-data";
import { formatTimeBySecond } from "@saas/components/src";
export default {
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myChart: null,
      dialogType: "attend", // attend 出勤 absent缺席
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      preThreeData: [],
      formatTimeBySecond,
    };
  },
  watch: {
    liveReport: {
      handler(val) {
        if (val && val.room_id) {
          this.loadTableData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    dialogTitle() {
      return "学员排名";
    },

    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  methods: {
    handleClickMore() {
      this.dialogVisible = true;
      this.currentPage = 1;
      this.loadTableData();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.tableData = [];
    },
    // 获取出勤学员
    getStudentRankList() {
      getStudentRankList({
        room_id: this.liveReport.room_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          if (this.currentPage === 1) {
            this.preThreeData = res.data.list.slice(0, 3);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async loadTableData() {
      try {
        this.getStudentRankList();
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$message.error("加载数据失败");
      }
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadTableData();
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadTableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  --student-ranking-card-bg: #ffffff;
  --student-ranking-surface-bg: #f7f8fa;
  --student-ranking-surface-alt-bg: #ffffff;
  --student-ranking-primary: #0d1400;
  --student-ranking-secondary: #515350;
  --student-ranking-muted: #4e5969;
  --student-ranking-data: #1d2129;
  --student-ranking-page-bg: #f2f3f5;
  --student-ranking-scrollbar-track: rgba(0, 0, 0, 0.1);
  --student-ranking-scrollbar-thumb: rgba(0, 0, 0, 0.3);

  html.dark & {
    --student-ranking-card-bg: var(--mg-bg-card);
    --student-ranking-surface-bg: var(--mg-bg-elevated);
    --student-ranking-surface-alt-bg: var(--mg-bg-surface);
    --student-ranking-primary: var(--mg-text-primary);
    --student-ranking-secondary: var(--mg-text-secondary);
    --student-ranking-muted: var(--mg-text-muted);
    --student-ranking-data: var(--mg-text-primary);
    --student-ranking-page-bg: var(--mg-control-bg);
    --student-ranking-scrollbar-track: var(--mg-bg-surface);
    --student-ranking-scrollbar-thumb: var(--mg-border-subtle);
  }

  width: 590px;
  height: 242px;
  background: var(--student-ranking-card-bg);
  border-radius: 24px 24px 24px 24px;
  .title {
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: var(--student-ranking-primary);
      margin-left: 8px;
    }
    .more-btn {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: var(--student-ranking-muted);
      margin-right: 24px;
      cursor: pointer;
      i {
        margin-left: 2px;
        font-size: 12px;
        color: var(--student-ranking-muted);
      }
    }
  }
  .comp-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 8px;
    padding: 0 24px;
    .echart-box {
      margin-left: 75px;
      width: 140px;
      height: 140px;
    }
    .right {
      width: 250px;
      margin-right: 50px;
      .item {
        width: 250px;
        height: 70px;
        background: var(--student-ranking-surface-bg);
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 12px;
        padding: 8px 8px 8px 16px;
        .top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .block {
            width: 10px;
            height: 10px;
            background: #83dcaf;
            border-radius: 3px 3px 3px 3px;
          }
          .label {
            font-weight: 400;
            font-size: 14px;
            color: var(--student-ranking-secondary);
            margin-left: 5px;
            flex: 1;
          }
          .more-icon {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
              transform: rotate(180deg);
              width: 6px;
              height: 9px;
            }
          }
        }
        .data {
          padding-left: 15px;
          margin-top: 6px;
          font-weight: bold;
          font-size: 24px;
          color: var(--student-ranking-primary);
          display: flex;
          height: 28px;
          line-height: 28px;
          .num {
            width: 87px;
          }
        }
      }
    }
  }
}

// 弹窗样式
::v-deep .student-dialog {
  width: 590px;
  height: 615px;
  background: var(--student-ranking-card-bg);
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    padding: 24px 24px 0 24px;
    border-bottom: none;
    position: relative;
    font-size: 16px;
    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: var(--student-ranking-primary);
      height: 22px;
      line-height: 22px;
      display: inline-block;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 22px;
      width: 24px;
      height: 24px;
      background: transparent;
      border: none;

      .el-dialog__close {
        color: var(--student-ranking-muted);
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    background: var(--student-ranking-card-bg);
    color: var(--student-ranking-primary);
    padding: 0 24px 24px;
    flex: 1;
    overflow: hidden;
  }
}
.table-header {
  display: flex;
  margin-bottom: 16px;
  padding: 0 10px;
  .header-cell {
    font-size: 12px;
    color: var(--student-ranking-secondary);
    font-weight: 400;
    &.student-name-header {
      width: 200px;
      text-align: left;
    }

    &.time-header {
      flex: 1;
      text-align: right;
    }

    &.course-header {
      flex: 1;
      text-align: right;
    }

    &.progress-header {
      flex: 1;
      text-align: right;
    }
  }
}

.student-table-body {
  flex: 1;
  overflow-y: auto;
  .student-table-row {
    margin-bottom: 8px;
    background: var(--student-ranking-surface-bg);
    border-radius: 12px;
    &:nth-of-type(even) {
      background: var(--student-ranking-surface-alt-bg);
    }
    .row-content {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      width: 100%;
      .student-info {
        display: flex;
        align-items: center;
        gap: 4px;
        width: 200px;
        text-align: left;
        .avatar {
          width: 20px;
          min-width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .student-name {
          font-size: 14px;
          color: var(--student-ranking-primary);
          font-weight: 400;
          line-height: 1.4;
        }
      }

      .data-cell {
        font-size: 14px;
        color: var(--student-ranking-data);
        text-align: right;
        flex: 1;
        &.time-cell,
        &.course-cell,
        &.progress-cell {
          text-align: right;
        }
      }
    }
  }
}
.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-tip {
    font-size: 14px;
    color: var(--student-ranking-primary);
    margin-top: 8px;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .table-header {
    display: flex;
    margin-bottom: 16px;
    padding-top: 18px;
    padding-right: 16px;
    .header-cell {
      font-size: 12px;
      color: var(--student-ranking-secondary);
      font-weight: 400;
      &.student-name-header {
        width: 200px;
        text-align: left;
      }

      &.time-header {
        flex: 1;
        text-align: right;
      }

      &.course-header {
        flex: 1;
        text-align: right;
      }

      &.progress-header {
        flex: 1;
        text-align: right;
      }
    }
  }

  .student-table-body {
    // 自定义滚动条样式，确保不影响布局
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: var(--student-ranking-scrollbar-track);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--student-ranking-scrollbar-thumb);
      border-radius: 3px;
      &:hover {
        background: var(--student-ranking-muted);
      }
    }
    .student-table-row {
      margin-bottom: 8px;
      background: var(--student-ranking-surface-bg);
      border-radius: 12px;
      &:nth-of-type(even) {
        background: var(--student-ranking-surface-alt-bg);
      }
      .row-content {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        width: 100%;
        .student-info {
          display: flex;
          align-items: center;
          gap: 4px;
          width: 200px;
          text-align: left;
          .avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .student-name {
            font-size: 14px;
            color: var(--student-ranking-primary);
            font-weight: 400;
            line-height: 1.4;
          }
        }

        .data-cell {
          font-size: 14px;
          color: var(--student-ranking-data);
          text-align: right;
          flex: 1;
          &.time-cell {
            text-align: right;
          }

          &.course-cell {
            color: var(--student-ranking-data);
            text-align: right;
          }

          &.progress-cell {
            text-align: right;
          }
        }
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: right;
    margin-top: 20px;

    .pagination {
      display: flex;
      align-items: center;
      gap: 4px;

      .pagination-btn {
        width: 20px;
        height: 32px;
        border: none;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
        padding: 8px 0;
        &.prev {
          transform: rotate(180deg);
        }
        &:hover:not(:disabled) {
          background: var(--student-ranking-surface-alt-bg);
        }

        &:disabled {
          background: var(--student-ranking-surface-alt-bg);
          cursor: not-allowed;

          img {
            opacity: 0.5;
          }
        }

        img {
          width: 12px;
          height: 12px;
        }
      }

      .pagination-info {
        display: flex;
        align-items: center;
        padding: 0 8px;
        font-size: 14px;
        color: var(--student-ranking-data);
        line-height: 1.57;

        .current-page {
          width: 40px;
          height: 28px;
          font-weight: 600;
          font-size: 14px;
          color: var(--student-ranking-muted);
          line-height: 28px;
          background: var(--student-ranking-page-bg);
          border-radius: 2px 2px 2px 2px;
          text-align: center;
        }

        .separator {
          margin: 0 8px;
        }

        .total-pages {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
